import { useRequiredContext } from "@redotech/react-util/context";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickFilledIcon from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const PostPurchaseItems = memo(function PostPurchaseItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_POST_PURCHASE_UPSELL}
      feature={ConversionFeature.POST_PURCHASE}
      FilledIcon={CursorClickFilledIcon}
      friendlyName="Post-purchase upsell"
      href={routes.getConversionSubRoute("post-purchase")}
      id="post-purchase"
      UnfilledIcon={CursorClickIcon}
    />
  );
});
